module.exports = __webpack_public_path__ + "static/media/reset.a330fde1.png";